export const RECOMMENDATION_MPV_CONFIG: Record<
  string,
  Record<string, { mainMpv: string; alternativeMpv: string }>
> = {
  'EU-*': {
    standingbanners: {
      mainMpv: 'retractableBanners',
      alternativeMpv: 'advertisingFlags'
    },
    hangingBanners: {
      mainMpv: 'euVinylBanners',
      alternativeMpv: 'portableExhibitionCounters'
    },
    wallfloorwindowDecals: {
      mainMpv: 'windowDecals',
      alternativeMpv: 'windowDecals'
    },
    carDecalsSigns: {
      mainMpv: 'carDoorMagnets',
      alternativeMpv: 'carDoorMagnets'
    },
    exhibitionCounters: {
      mainMpv: 'portableExhibitionCounters',
      alternativeMpv: 'euVinylBanners'
    },
    tabledisplayandMenu: {
      mainMpv: 'tabletopSigns',
      alternativeMpv: 'counterDisplays'
    },
    tableclothsCovering: {
      mainMpv: 'tablecloths',
      alternativeMpv: 'counterDisplays'
    },
    outdoorDisplay: {
      mainMpv: 'printedGazeboTents',
      alternativeMpv: 'printedGazeboTents'
    },
    pointofsalesdisplays: {
      mainMpv: 'fourSidedFloorDisplays',
      alternativeMpv: 'posters'
    },
    pavementSigns: {
      mainMpv: 'aFrames',
      alternativeMpv: 'aFrames'
    },
    tentsDisplays: {
      mainMpv: 'popUps',
      alternativeMpv: 'popUps'
    },
    rigidsigns: {
      mainMpv: 'lawnSigns',
      alternativeMpv: 'fourSidedFloorDisplays'
    },
    postersEu: {
      mainMpv: 'posters',
      alternativeMpv: 'posters'
    },
    signsAccessories: {
      mainMpv: 'easels',
      alternativeMpv: 'lawnSigns'
    },
    shippingboxesEnvelopes: {
      mainMpv: 'mailerBoxes',
      alternativeMpv: 'promotionalBoxesEu'
    },
    mailingLabelss: {
      mainMpv: 'envelopeSeals',
      alternativeMpv: 'returnAddressLabels'
    },
    stampsAndInk: {
      mainMpv: 'selfInkingStamps',
      alternativeMpv: 'coloredEnvelopes'
    },
    paperBags: {
      mainMpv: 'paperBag',
      alternativeMpv: 'promotionalBoxesEu'
    },
    tags: {
      mainMpv: 'hangTags',
      alternativeMpv: 'paperTogobags'
    },
    cardboardBoxes: {
      mainMpv: 'promotionalBoxesEu',
      alternativeMpv: 'plainShippingBoxes'
    },
    doypacks: {
      mainMpv: 'flexiblePackagingDoypacks',
      alternativeMpv: 'paperBag'
    },
    corrugatedCardboardBoxes: {
      mainMpv: 'mailerBoxes',
      alternativeMpv: 'promotionalBoxesEu'
    },
    foldingCartonBoxes: {
      mainMpv: 'promotionalBoxesEu',
      alternativeMpv: 'shippingBoxes'
    },
    packagingaccessories: {
      mainMpv: 'newpackagingtape',
      alternativeMpv: 'newpackagingtape'
    },
    basicPapersBusinessCards: {
      mainMpv: 'matteBusinessCards',
      alternativeMpv: 'metalBusinessCardHolder'
    },
    shapesBusinessCards: {
      mainMpv: 'standardBusinessCards',
      alternativeMpv: 'metalBusinessCardHolder'
    },
    naturalPapersBusinessCards: {
      mainMpv: 'recycledMatteBusinessCards',
      alternativeMpv: 'metalBusinessCardHolder'
    },
    uniqueTexturesBusinessCards: {
      mainMpv: 'softTouchBusinessCards',
      alternativeMpv: 'metalBusinessCardHolder'
    },
    premiumFinisheBusinessCards: {
      mainMpv: 'spotUVBusinessCards',
      alternativeMpv: 'metalBusinessCardHolder'
    },
    useCasesBusinessCards: {
      mainMpv: 'loyaltyCards',
      alternativeMpv: 'loyaltyCards'
    },
    premiumBusinessCards: {
      mainMpv: 'softTouchBusinessCards',
      alternativeMpv: 'metalBusinessCardHolder'
    },
    businessCardHolders: {
      mainMpv: 'standardBusinessCards',
      alternativeMpv: 'standardBusinessCards'
    },
    notebooksjournals: {
      mainMpv: 'journals',
      alternativeMpv: 'journals'
    },
    notepadsInvoicePadsStickies: {
      mainMpv: 'notepads',
      alternativeMpv: 'customEnvelopes'
    },
    envelopesandLetterheads: {
      mainMpv: 'businessEnvelopes',
      alternativeMpv: 'presentationFolders'
    },
    notecardsInvitations: {
      mainMpv: 'noteCards',
      alternativeMpv: 'postcards'
    },
    flyersandFoldedLeaflets: {
      mainMpv: 'flyersandLeaflets',
      alternativeMpv: 'flyersandLeaflets'
    },
    personalizedPostcards: {
      mainMpv: 'postcards',
      alternativeMpv: 'postcards'
    },
    bookletsandCatalogs: {
      mainMpv: 'stapledBooklets',
      alternativeMpv: 'stapledBooklets'
    },
    folders: {
      mainMpv: 'presentationFolders',
      alternativeMpv: 'presentationFolders'
    },
    menusPrinting: {
      mainMpv: 'menus',
      alternativeMpv: 'menus'
    },
    flyersPostacardsAndHandouts: {
      mainMpv: 'flyersandLeaflets',
      alternativeMpv: 'posters'
    },
    ticketsAndLoyaltyCards: {
      mainMpv: 'customTickets',
      alternativeMpv: 'customTickets'
    },

    magnets: {
      mainMpv: 'magneticPostcards',
      alternativeMpv: 'postcards'
    },
    leafletDispensers: {
      mainMpv: 'foldedLeaflets',
      alternativeMpv: 'foldedLeaflets'
    },
    customstickerSingles: {
      mainMpv: 'stickerSingles',
      alternativeMpv: 'customStickers'
    },
    sheetstickers: {
      mainMpv: 'customStickers',
      alternativeMpv: 'stickerSingles'
    },
    labelsAndTags: {
      mainMpv: 'rollLabels',
      alternativeMpv: 'stickerSingles'
    },
    sheetLabels: {
      mainMpv: 'productLabels',
      alternativeMpv: 'stickerSingles'
    },
    fabricDisplays: {
      mainMpv: 'tripleSidedFloorDisplay',
      alternativeMpv: 'tripleSidedFloorDisplay'
    },
    promotionalFurniture: {
      mainMpv: 'horecaUmbrellas',
      alternativeMpv: 'printedGazeboTents'
    }
  }
}

export const RECOMMENDATIONS_PAGE_TYPE_MAP: { [key: string]: string } = {
  'related products': 'category-page',
  'frequently ordered': 'category-page-2'
}
